import { createFileRoute } from '@tanstack/react-router'
import { KelolaJabatan } from '../../../../components/KelolaJabatan'

export const Route = createFileRoute('/platform/desa/$desaId/jabatan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <KelolaJabatan desaId={desaId} />
  },
})
